export * from './data-contracts';
export * from './http-client';

import { fetchWithRequestId } from './fetch-with-request-id';
import { V1 } from './V1';

export const api = new V1({
	baseUrl: process?.env?.NEXT_FETCH_BASE ?? '',
	customFetch: fetchWithRequestId,
	baseApiParams: {
		credentials: 'include',
	},
});
